<style>
.btn {margin: 0px auto;height: 60px;z-index: 9999;}
.btn .el-button {height: 40px;margin: 10px auto;}
.btn {position: fixed;bottom: 0;left: 0;right: 0;height: 60px;background: #f8f4f4;margin-left: 240px;background-color: #dff0d8;}
</style>

<template>
  <div>
    <el-tree
      :data="data"
      show-checkbox
      node-key="id"
      ref="tree"
      highlight-current
      :default-checked-keys='defaultArr'
      :props="defaultProps"
      @check="getCheckedNodes">
    </el-tree>
    <div class="btn">
      <el-button type="success" @click="addfn()" v-if="this.$route.path === '/Rolegl' && this.show === false">添加</el-button>
      <el-button type="success" @click="updatefn()" v-if="this.$route.path === '/Rolegl'  && this.show === true">修改</el-button>
      <el-button @click="cancelfn()" v-if="this.$route.path === '/Rolegl'">取消</el-button>

    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex'
export default {
  data()
  {
    return {
      treeList: [],
      data: [],
      menuData: [],
      treeInfo: [],
      defaultArr: [],
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      show: false
    }
  },
  created()
  {
    this.getTree()
    this.getFindTree()
  },
  computed:
  {
    ...mapState({
      getTreeid: state => state.Treeid
    })
  },
  watch:
  {
    getTreeid:
    {
      handler(nval, oval)
      {
        this.roleId = nval
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    getTree()
    {
      let paras1 = {
        cmd: 'query',
        _major: 99,
        _minor: 19,
        _exp: 'id>0'
      }
      window.post.getPost(paras1).then((ret) =>
      {
        this.menuData = this.toTree(ret, 'id', 'glid')
      })
    },
    toTree(data, code, ParentCode)
    {
      let qlevel1 = []
      let qlevel2 = []
      let qlevel3 = []
      data = data.map((item) =>
      {
        return {
          id: item.id,
          name: item.name,
          qlevel: item.qlevel,
          glid: item.glid,
          children: []
        }
      })
      data.forEach((item) =>
      {
        if (item.qlevel === '1')
          qlevel1.push(item)
        if (item.qlevel === '2')
          qlevel2.push(item)
        if (item.qlevel === '3')
          qlevel3.push(item)
      })
      qlevel2.forEach((item2) =>
      {
        qlevel3.forEach((item3) =>
        {
          if (item2.id === +item3.glid)
            item2.children.push(item3)
        })
      })
      qlevel1.forEach((item1) =>
      {
        qlevel2.forEach((item2) =>
        {
          if (item1.id === +item2.glid)
            item1.children.push(item2)
        })
      })
      this.data = qlevel1
    },
    //添加树权限
    addfn()
    {
      // //添加之前先删除之前先设置的树
      // let paras1 = {
      //   cmd: 'delRoleObj',
      //   roleid: `${this.roleId}`,
      //   type: 1,
      //   sys: 11
      // }
      // window.post.getIdentitySvr(paras1)
      //添加树
      let treedata = []
      this.treeInfo.forEach(e =>
      {
        treedata.push({sys: 11, type: 1, roleid: `${this.roleId}`, major: 0, minor: 0, objectid: e})
      })
      let obj = {
        cmd: 'adds',
        _major: 99,
        _minor: 18,
        json: JSON.stringify(treedata)
      }
      window.post.getPost(obj).then((ret) =>
      {
        if (ret.ret === 1)
          this.$message({message: '设置失败', type: 'error', customClass: 'mzindex'})
        else
        {
          this.$message({message: '设置成功', type: 'success', customClass: 'mzindex'})
          this.$emit('removeTab')
        }
      })
    },
    // 修改
    updatefn()
    {
      //添加之前先删除之前先设置的树
      let paras1 = {
        cmd: 'delRoleObj',
        roleid: `${this.roleId}`,
        type: 1,
        sys: 11
      }
      window.post.getIdentitySvr(paras1)
      //添加树
      let treedata = []
      this.treeInfo.forEach(e =>
      {
        treedata.push({sys: 11, type: 1, roleid: `${this.roleId}`, major: 0, minor: 0, objectid: e})
      })
      let obj = {
        cmd: 'adds',
        _major: 99,
        _minor: 18,
        json: JSON.stringify(treedata)
      }
      window.post.getPost(obj).then((ret) =>
      {
        if (ret.ret === 1)
          this.$message({message: '设置失败', type: 'error', customClass: 'mzindex'})
        else
        {
          this.$message({message: '设置成功', type: 'success', customClass: 'mzindex'})
          this.$emit('removeTab')
        }
      })
    },
    getCheckedNodes(data, node)
    {
      this.treeInfo = []
      this.treeInfo = node['checkedKeys']
    },
    getFindTree()
    {
      let paras = {
        cmd: 'query',
        _major: 99,
        _minor: 18,
        _exp: `roleid= ${this.roleId}`
      }
      window.post.getPost(paras).then((ret) =>
      {
        if (ret.length > 0)
        {
          this.show = true
          ret.forEach(data =>
          {
            this.defaultArr.push(data.objectid)
          })
          this.$refs.tree.setCheckedKeys(this.defaultArr)
        }
        else
          this.show = false
      })
    },
    // 取消
    cancelfn()
    {
      this.$emit('removeTab')
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/plugins/backer/assembly/TreeSet.vue